import { render, staticRenderFns } from "./preview-assets.vue?vue&type=template&id=2ae01bfa&scoped=true"
import script from "./preview-assets.vue?vue&type=script&lang=ts"
export * from "./preview-assets.vue?vue&type=script&lang=ts"
import style0 from "./preview-assets.vue?vue&type=style&index=0&id=2ae01bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae01bfa",
  null
  
)

export default component.exports